export enum EUserStoreRole {
  OWNER = 'OWNER',
  GUEST = 'GUEST',
}
